module.exports = __webpack_public_path__ + "static/shape-11-83278e6f7df786ec9a29fb7085dc961c.svg";